var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.card)?_c('div',{staticClass:"duedate"},[_c('transition',{attrs:{"name":"zoom"}},[(_vm.card.duedate)?_c('div',{class:_vm.dueIcon},[_c('span',[_vm._v(_vm._s(_vm.relativeDate))])]):_vm._e()])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }